<template>
  <div class="resume-education-wrap clearfix" v-if="education&&education.length">
    <div class="progress-content">
      <ul>
        <li class="clearfix" v-for="(edu,index) in education" :key="index">
          <em></em>
          <i></i>
         <div class="img-wrap">
             <img :src="edu.schoolLogoUrl | avatar('school')">
          </div>
          <div class="info-box">
            <p>{{edu.startTime}} - {{edu.endTime | formatMonthSelect}}</p>
            <p v-if="edu.school" v-html="edu.school"></p>
            <p class="separate-info-list clearfix">
              <span v-if="edu.degreeId || edu.recruitmentStatus">{{edu.recruitmentStatus ? recruitmentStatus[parseInt(edu.recruitmentStatus)] : ''}}<span v-if="edu.degreeId">{{edu.degreeId | degree}}</span></span>
              <span v-if="edu.profession" v-html="edu.profession"></span>
            </p>
            <p class="remark" v-if="edu.remark" v-html="edu.remark"></p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<style scoped lang="scss">
    .img-wrap{
        border-radius: 0;
    }
</style>
<script>
export default {
  props:{
    education: {}
  },
  data(){
    return{
      recruitmentStatus: METADATA.recruitmentStatus
    };
  },
  components: {
  },
  methods: {
  },
  created() {
  }
};
</script>
